module.exports = __webpack_public_path__ + "img/tab-image-yoga-presentation.e5162c56.png";